import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { LanguageProvider, useLang, withLang } from "./i18n";
import { globalCss, colors, fontHeading } from "./theme";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import CarPage from "./pages/CarPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

// Shown for unknown URLs (served by Netlify as 404.html with a real 404 status).
function NotFound() {
  const { t, lang } = useLang();
  return (
    <div style={{ padding: "120px 40px", minHeight: "60vh", textAlign: "center" }}>
      <h1 style={{ fontFamily: fontHeading, color: colors.ink }}>{t.pageNotFoundTitle}</h1>
      <p style={{ color: colors.body, marginBottom: 24 }}>{t.pageNotFoundSub}</p>
      <Link to={`${withLang("/", lang)}#coches`} style={{ color: colors.red, fontWeight: 600, fontFamily: fontHeading }}>
        {t.backToCars}
      </Link>
    </div>
  );
}

// The whole site minus the router, so it can be rendered both in the browser
// (BrowserRouter, below) and at build time (StaticRouter, scripts/prerender.js).
export function AppShell({ cars, loading }) {
  return (
    <LanguageProvider>
      <style>{globalCss}</style>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home cars={cars} loading={loading} />} />
        <Route path="/coche/:id" element={<CarPage cars={cars} loading={loading} />} />
        <Route path="/en" element={<Home cars={cars} loading={loading} />} />
        <Route path="/en/coche/:id" element={<CarPage cars={cars} loading={loading} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </LanguageProvider>
  );
}

export default function App() {
  // Prerendered pages embed the car list (window.__CARS__) so the first
  // render matches the static HTML and nothing has to be fetched.
  const initialCars = typeof window !== "undefined" ? window.__CARS__ : undefined;
  const [cars, setCars] = useState(initialCars || []);
  const [loading, setLoading] = useState(!initialCars);

  useEffect(() => {
    if (initialCars) return;
    fetch("/data/cars.json")
      .then((r) => r.json())
      .then((data) => {
        setCars(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BrowserRouter>
      <AppShell cars={cars} loading={loading} />
    </BrowserRouter>
  );
}
